import { AxiosError, AxiosResponse } from 'axios';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { FC } from 'react';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { AgentService } from 'services/AgentService';
import { ClientPaymentRequestDto } from 'services/AgentService/types';
import { BaseError } from 'types';
import { Button } from 'ui/redesign/Button';
import { ButtonVariant } from 'ui/redesign/Button/constants';
import { ClientOrderDetailsViewSuccessFormProps } from './types';

export const ClientOrderDetailsViewSuccessForm: FC<ClientOrderDetailsViewSuccessFormProps> = ({
  order,
  setActualOrder,
}) => {
  const dispatch = useAppDispatch();

  const { mutateAsync: clientOrderDetailsViewApprove } = useMutation<
    AxiosResponse<ClientPaymentRequestDto>,
    AxiosError<BaseError>,
    { orderId: string; concurrencyStamp: string }
  >({
    mutationKey: 'clientOrderDetailsViewApprove',
    mutationFn: ({ orderId, concurrencyStamp }) =>
      AgentService.clientOrderDetailsViewApprove(orderId, concurrencyStamp),
    onSuccess: ({ data }) => {
      dispatch(modalActions.closeModal());
      setActualOrder(data);
    },
    onError: (data) => {
      data.response?.data.errors
        ? Object.values(data.response?.data.errors).forEach((errors) =>
            errors.forEach((message) => toast.error(message))
          )
        : toast.error(data.response?.data.detail);
    },
  });

  return (
    <div className="z-10 mt-8 flex justify-end">
      <Button
        variant={ButtonVariant.OUTLINE}
        className="mr-5"
        type="button"
        onClick={() => dispatch(modalActions.closeModal())}
      >
        ОТМЕНИТЬ
      </Button>
      <Button
        variant={ButtonVariant.PRIMARY}
        onClick={() =>
          order.concurrencyStamp &&
          clientOrderDetailsViewApprove({
            orderId: order.id,
            concurrencyStamp: order.concurrencyStamp,
          })
        }
      >
        УТВЕРДИТЬ
      </Button>
    </div>
  );
};
